import moment from 'moment';
import { arrayOf, number, oneOfType, shape, string } from 'prop-types';
import React from 'react';
import { PieChart } from 'react-chartkick';
import { Col, FormGroup, Label, Row } from 'reactstrap';

import CurrencyFormat from '../generic/CurrencyFormat';

const BUDGET_COLORS = [
  '#f2cd0d',
  '#f2b20d',
  '#eb8c00',
  '#dc6900',
  '#e0301e',
  '#a32020',
  '#602320',
];

function CampaignStatistics({ data }) {
  return (
    <Row className="small">
      <Col sm="5">
        <FormGroup row className="mb-0">
          <Col>
            <Label className="pr-1" for="cs-budget">
              Budget {moment().year()}:
            </Label>
            <CurrencyFormat
              id="cs-budget"
              value={data.allCampaignsBudget}
              text
            />
          </Col>
        </FormGroup>
        <FormGroup row className="mb-0">
          <Col>
            <Label className="pr-1" for="cs-pipeline">
              Sales Pipeline (open, weighted):
            </Label>
            <CurrencyFormat
              id="cs-pipeline"
              value={data.opportunityRevenue}
              text
            />
          </Col>
        </FormGroup>
        <FormGroup row className="mb-0">
          <Col>
            <Label className="pr-1" for="cs-ended">
              Campaigns Ended {moment().year()}:
            </Label>
            <span id="cs-ended">{data.endedCampaigns}</span>
          </Col>
        </FormGroup>
        <FormGroup row className="mb-0">
          <Col>
            <Label className="pr-1" for="cs-active">
              Campaigns Active:
            </Label>
            <span id="cs-active">{data.runningCampaigns}</span>
          </Col>
        </FormGroup>
      </Col>
      <Col sm="7">
        <Row>Campaigns budgets by categories</Row>
        <Row>
          <Col sm="6">
            <PieChart
              colors={BUDGET_COLORS}
              data={data.pieChartData}
              legend={false}
            />
          </Col>
          <Col sm="6">
            <table>
              <tbody>
                {data.budgetByCategories.map(b => (
                  <tr key={b.title}>
                    <td>{b.title}</td>
                    <td>
                      <CurrencyFormat value={b.value} text />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

CampaignStatistics.propTypes = {
  data: shape({
    allCampaignsBudget: number,
    endedCampaigns: number,
    budgetByCategories: arrayOf(
      shape({
        title: string.isRequired,
        value: number.isRequired,
        percentage: number.isRequired,
      }),
    ),
    opportunityRevenue: number,
    pieChartData: arrayOf(arrayOf(oneOfType([string, number]))),
    runningCampaigns: number,
  }).isRequired,
};

export default CampaignStatistics;
